(function ($) {
	$(document).ajaxStart($.blockUI).ajaxStop($.unblockUI);

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		common: {
			init: function () {},
			finalize: function () {
				ACTDIG.Funcs.init();
				ACTDIG.Ajax.init();
				ACTDIG.AdBanners.init();
			},
		},
		page_template_attendees: {
			finalize: function () {
				ACTDIG.Attendees.init();
			},
		},
		page_template_unplugged: {
			finalize: function () {
				ACTDIG.Unplugged.init();
			},
		},
		page_template_aviation_meetings: {
			finalize: function () {
				ACTDIG.AviationMeetings.init();
			},
		},
		page_template_about_our_hosts: {
			finalize: function () {
				ACTDIG.AboutOurHosts.init();
			},
		},
		page_template_partners: {
			finalize: function () {
				ACTDIG.Partners.init();
			},
		},
		page_template_speakers: {
			finalize: function () {
				ACTDIG.Speakers.init();
			},
		},
		page_template_programme: {
			finalize: function () {
				ACTDIG.Programme.init();
			},
		},
		page_template_programme_schedule: {
			finalize: function () {
				ACTDIG.Programme.init();
			},
		},
		page_template_programme_conference: {
			finalize: function () {
				ACTDIG.Programme.init();
			},
		},
		page_template_evening_functions: {
			finalize: function () {
				ACTDIG.EveningFunctions.init();
			},
		},
		page_template_venue: {
			finalize: function () {
				ACTDIG.Venue.init();
				ACTDIG.Map.init();
			},
		},
		page_template_travel_guide: {
			finalize: function () {
				ACTDIG.TravelGuide.init();
				ACTDIG.Map.init();
			},
		},
		page_template_hotels: {
			finalize: function () {
				ACTDIG.Hotels.init();
			},
		},
		page_template_excursions: {
			finalize: function () {
				ACTDIG.Excursions.init();
			},
		},
		page_template_city_guide: {
			finalize: function () {
				ACTDIG.CityGuide.init();
			},
		},
		page_template_why_attend: {
			finalize: function () {
				ACTDIG.WhyAttend.init();
			},
		},
		page_template_why_host: {
			finalize: function () {
				ACTDIG.WhyHost.init();
			},
		},
		page_template_sponsor: {
			finalize: function () {
				ACTDIG.Sponsor.init();
			},
		},
		page_template_exhibit: {
			finalize: function () {
				ACTDIG.Exhibit.init();
			},
		},
		page_template_videos: {
			finalize: function () {
				ACTDIG.Videos.init();
			},
		},
		page_template_route_stimulation_tool: {
			finalize: function () {
				ACTDIG.RouteStimulationTool.init();
			},
		},
		// plop:js
	};
	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? "init" : funcname;
			fire = func !== "";
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === "function";

			if (fire) {
				setTimeout(function () {
					namespace[func][funcname](args);
				}, 0);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire("common");

			// Fire page-specific init JS, and then finalize JS
			$.each(
				document.body.className.replace(/-/g, "_").split(/\s+/),
				function (i, classnm) {
					UTIL.fire(classnm);
					UTIL.fire(classnm, "finalize");
				}
			);

			// Fire common finalize JS
			UTIL.fire("common", "finalize");
		},
	};

	// Load Events
	document.addEventListener("DOMContentLoaded", function () {
		UTIL.loadEvents();
	});
})(jQuery); // Fully reference jQuery after this point.
